interface ISportAndLeague {
  name: string;
  leagues: ILeagueAndBundle[];
}
interface ILeagueAndBundle {
  name: string;
  bundles: BUNDLES[];
}

export enum BUNDLES {
  USA = 'USA',
  AUSTRALASIA = 'AUSTRALASIA',
}

export const EXCLUDED_GROUPS_VENDORS = ['nznbl'];

export const VENDORS = [
  {id: 'warriors', label: 'Warriors'},
  {id: 'wahsquiz', label: 'Warriors Trivia'},
  {id: 'crusaders', label: 'Crusaders'},
  {id: 'hurricanes', label: 'Hurricanes'},
  {id: 'blackcaps', label: 'Blackcaps'},
  {id: 'rabbitohs', label: 'Rabbitohs'},
  {id: 'dodgers', label: 'Dodgers'},
  {id: 'superrugby', label: 'Super Rugby'},
  {id: 'stateoforigin', label: 'State Of Origin'},
  {id: '49ers', label: '49ers'},
  {id: 'bteam', label: 'UCLA BTeam'},
  {id: 'samsncaa', label: 'Sams NCAA'},
  {id: 'calbears', label: 'California Bears'},
  {id: 'chancernfl', label: 'Chancer NFL'},
  {id: 'jkbogen', label: 'Jake Ellenbogen'},
  {id: 'maxg', label: 'Max G'},
  {id: 't20worldcup', label: 'T20 World Cup'},
  {id: 'crowdgoeswild', label: 'Crowd Goes Wild'},
  {id: 'nblxnba', label: 'NBL x NBA'},
  {id: '1news', label: '1News'},
  {id: 'awards', label: 'Awards'},
  {id: 'mediaawards', label: 'Media Awards'},
  {id: 'fifawwc', label: 'FIFA WWC'},
  {id: 'rwc23', label: 'RWC23'},
  {id: 'nzsport', label: 'NZ SPORT'},
  {id: 'nzmotors', label: 'NZ MOTORS'},
  {id: 'nzwomen', label: 'NZ WOMEN'},
  {id: 'nznbl', label: 'NZ NBL'},
  {id: 'nznblrapid', label: 'NZ NBL Rapid League'},
  {id: 'nblsaints', label: 'Wellington Saints'},
  {id: 'nblrams', label: 'Canterbury Rams'},
  {id: 'nbltuatara', label: 'Auckland Tuatara'},
  {id: 'hoopheads', label: 'Hoop Heads'},
  {id: 'womenzsports', label: 'Womenz Sports'},
  {id: 'nzrugby', label: 'NZ Rugby'},
  {id: 'nbl', label: 'Australian NBL'},
  {id: 'breakers', label: 'NZ Breakers'},
  {id: 'nbl-minileague', label: 'NBL Mini League'},
  {id: 'nrl', label: 'National Rugby League'},
  {id: 'aleague', label: 'A League'},
  {id: 'npc', label: 'NPC'},
  {id: 'arsenal', label: 'Arsenal'},
];

export const VENDOR_IDS = VENDORS.map((v) => v.id);

export const SPORTS_DATA: ISportAndLeague[] = [
  {name: 'Baseball', leagues: [{name: 'mlb', bundles: [BUNDLES.USA]}]},
  {
    name: 'American Football',
    leagues: [
      {name: 'nfl', bundles: [BUNDLES.USA]},
      {name: 'ncaa', bundles: [BUNDLES.USA]},
    ],
  },
  {
    name: 'Basketball',
    leagues: [
      {name: 'nba', bundles: [BUNDLES.USA]},
      {name: 'nbl', bundles: [BUNDLES.AUSTRALASIA]},
      {name: 'wbc', bundles: [BUNDLES.AUSTRALASIA]},
    ],
  },
  {
    name: 'Rugby League',
    leagues: [{name: 'nrl', bundles: [BUNDLES.AUSTRALASIA]}],
  },
  {
    name: 'Rugby Union',
    leagues: [
      {name: 'intl', bundles: [BUNDLES.USA, BUNDLES.AUSTRALASIA]},
      {name: 'rwc', bundles: [BUNDLES.USA, BUNDLES.AUSTRALASIA]},
      {name: 'npc', bundles: [BUNDLES.AUSTRALASIA]},
      {name: 'super rugby', bundles: [BUNDLES.AUSTRALASIA]},
      {name: 'black ferns', bundles: [BUNDLES.AUSTRALASIA]},
      {name: 'all', bundles: [BUNDLES.USA, BUNDLES.AUSTRALASIA]},
    ],
  },
  {
    name: 'Football',
    leagues: [
      {name: 'fifa', bundles: [BUNDLES.USA, BUNDLES.AUSTRALASIA]},
      {name: 'epl', bundles: [BUNDLES.USA, BUNDLES.AUSTRALASIA]},
    ],
  },
  {
    name: 'Motorsport',
    leagues: [{name: 'supercars', bundles: [BUNDLES.AUSTRALASIA]}],
  },
  {
    name: 'Cricket',
    leagues: [
      {name: 't20 internationals', bundles: [BUNDLES.AUSTRALASIA]},
      {name: 'test cricket', bundles: [BUNDLES.AUSTRALASIA]},
    ],
  },
  {
    name: 'Media',
    leagues: [
      {name: 'sky tv', bundles: [BUNDLES.AUSTRALASIA]},
      {name: '1news', bundles: [BUNDLES.AUSTRALASIA]},
      {name: 'awards', bundles: [BUNDLES.AUSTRALASIA]},
    ],
  },
];

export const SPORTS = SPORTS_DATA.map((s) => s.name);

export const LEAGUES = SPORTS_DATA.reduce(
  (leagues: string[], sportAndLeague: ISportAndLeague) =>
    leagues.concat(sportAndLeague.leagues.map((l) => l.name)),
  [],
);

export const LEAGUES_BY_SPORT = SPORTS_DATA.map((s) => ({
  ...s,
  leagues: s.leagues.map((l) => l.name),
}));

type LeagueByBundle = Record<BUNDLES, string[]>;

export const LEAGUES_BY_BUNDLE = SPORTS_DATA.reduce(
  (leagues: Partial<LeagueByBundle>, sportAndLeague: ISportAndLeague) => {
    sportAndLeague.leagues.forEach((l) => {
      l.bundles.forEach((b) => {
        if (!leagues[b]) {
          leagues[b] = [];
        }
        leagues[b]?.push(l.name);
      });
    });
    return leagues;
  },
  {},
) as LeagueByBundle;
